<template>
  <div class="comp_wrap">
    <div class="comp_left">
      <div class="comp_input">
        <span class="comp_span">统计方式：</span>
        <a-select
          show-search
          optionFilterProp="children"
          v-model="form.statistics"
          @change="changeStat"
          style="width: 220px; font-size: 13px;"
        >
          <a-select-option
            v-for="(item, index) in statisticsArr"
            :key="index"
            :value="item.id"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </div>

      <div
        class="comp_input"
        style="height:70px"
        v-if="form.statistics == 'SHIFT'"
      >
        <span v-if="form.statistics == 'SHIFT'">
          <span class="comp_span">班次选择：</span>
          <a-checkbox-group v-model="form.shift">
            <a-checkbox
              v-for="(item, index) in shiftArr"
              :key="index"
              :value="item.key"
            >
              {{ item.name }}
            </a-checkbox>
          </a-checkbox-group>

          <!-- <a-radio-group style="font-size: 13px;" v-model="form.shift">
            <a-radio v-for="(item,index) in shiftArr" :key="index" :value="item.key">
              {{item.name}}
            </a-radio>
          </a-radio-group> -->
        </span>
      </div>

      <div class="comp_input">
        <span class="comp_span">时间范围：</span>
        <span v-if="form.statistics == 'DAY'">
          <a-range-picker
            :allowClear="false"
            v-model="form.timeRound"
            @change="dateChange"
            style="width: 220px; font-size: 13px;"
          />
        </span>

        <span v-if="form.statistics == 'WEEK'">
          <a-week-picker
            :allowClear="false"
            v-model="form.timeRound[0]"
            size="default"
            style="width: 110px; font-size: 13px;"
          />
          <a-week-picker
            :allowClear="false"
            v-model="form.timeRound[1]"
            size="default"
            style="width: 110px; font-size: 13px;"
          />
        </span>

        <span v-if="form.statistics == 'MONTH'">
          <a-range-picker
            :allowClear="false"
            style="width: 220px; font-size: 13px;"
            format="YYYY-MM"
            :value="form.timeRound"
            :mode="mode"
            @panelChange="monthChangeA"
            @change="monthChangeB"
          />
        </span>

        <span v-if="form.statistics == 'SHIFT'">
          <a-range-picker
            :allowClear="false"
            v-model="form.timeRound"
            style="width: 220px; font-size: 13px;"
          />
        </span>
      </div>

      <div class="comp_input">
        <span class="comp_span">产品类型：</span>
        <a-select
          allowClear
          show-search
          optionFilterProp="children"
          v-model="form.type"
          style="width: 220px; font-size: 13px;"
        >
          <a-select-option
            v-for="(item, index) in productArr"
            :key="index"
            :value="item.id"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </div>
      <div class="comp_input">
        <span class="comp_span">产品名称：</span>
        <a-input v-model="form.name" style="width: 220px; font-size: 13px;" />
      </div>
      <div class="comp_input">
        <span class="comp_span">计划编号：</span>
        <a-input
          v-model="form.planCode"
          style="width: 220px; font-size: 13px;"
        />
      </div>
      <div class="mdc-left-tree" :style="{ height: `calc(100% - 420px)` }">
        <a-tree
          v-model="checkedKeys"
          checkable
          :checkedKeys="checkedKeys"
          :expandedKeys="expendKeys"
          :tree-data="treeData"
          @expand="expandKey"
          @check="onSelect"
        />
      </div>

      <div class="comp_input" style="display: flex; justify-content: flex-end;">
        <a-button style="margin-right: 10px;" type="primary" @click="searchFn"
          >查询</a-button
        >
      </div>
    </div>
    <div class="comp_right">

      <div class="comp_right_excl">
        <!-- <a-button style="margin-left: 10px;" type='primary' >导出</a-button> -->
        <div class="flex">
          <export-button
            v-if="typeSearch === '产品查询'"
            style="margin-left: 10px;"
            filename="生产综合统计.xlsx"
            :exportFn="exportFn"
          />
          <export-button
            v-if="typeSearch === '工位查询'"
            style="margin-left: 10px;"
            filename="生产综合统计.xlsx"
            :exportFn="exportWork"
          />
        </div>

        <a-select
                label-in-value
                style="width: 120px; margin-left: 10px;"
                @change="changeProduction"
                v-model="defaultSelect"
              >
                <a-select-option v-for="(item,index) in selectArr" :value='item.value' :key="index">
                  {{item.label}}
                </a-select-option>

              </a-select>
      </div>


      <div class="comp_right_header">
        <a-radio-group v-model="typeSearch" style="margin-left: 10px;" @change="onChange">
          <a-radio-button value="产品查询">
            产品查询
          </a-radio-button>
          <a-radio-button value="工位查询">
            工位查询
          </a-radio-button>
        </a-radio-group>
      </div>
      <div v-if="typeSearch === '产品查询'">
        <div class="comp_right_time">
          <a-tabs v-model="chooseTab" @change="changeTab">
            <a-tab-pane
              v-for="(item, index) in tabArr"
              :key="index"
              :tab="item"
            >
            </a-tab-pane>
          </a-tabs>
        </div>

        <div class="comp_container">
          <!-- :pagination="pagination" -->
          <ml-table
            style="width: 100%; height: 100%;"
            :scroll="{ x: 1060, y: 560 }"
            :columns="palnCol"
            :data-source="planData"
            bordered
            :customRow="customRow"
            :rowSelection="{
              selectedRowKeys: this.selectedRowKeys,
              onChange: this.onSelectChange,
            }"
          >
            <!-- 日期 -->
            <template slot="date" slot-scope="text">
              <div>
                <span>{{ text }}</span>
              </div>
            </template>
          </ml-table>
        </div>
      </div>

      <div v-if="typeSearch === '工位查询'">
        <div class="comp_right_time">
          <a-tabs v-model="chooseTab" @change="changeTab">
            <a-tab-pane
              v-for="(item, index) in tabArr"
              :key="index"
              :tab="item"
            >
            </a-tab-pane>
          </a-tabs>
        </div>

        <div class="comp_container">
          <!-- :pagination="pagination" -->
          <ml-table
            style="width: 100%; height: 100%;"
            :scroll="{ x: 1060, y: 560 }"
            :columns="workStationIdCol"
            :data-source="workStationData"
            bordered
            :customRow="customRow2"
            :rowSelection="{
              selectedRowKeys: this.selectedRowKeys2,
              onChange: this.onSelectChange2,
            }"
          >
            <!-- 日期 -->
            <template slot="date" slot-scope="text">
              <div>
                <span>{{ text }}</span>
              </div>
            </template>
          </ml-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import moment from "moment";
import dayjs from "dayjs";
import { DataTreeNode } from "@/utils/array";
import {
  ProductionStatisticsServiceProxy,
  ProductionPlanTypeProductTypeServiceProxy,
} from "@/service-proxies/app-v2/coproduction.service-proxies";
import { ShiftServiceProxy } from "@/service-proxies/app-v2/time.service-proxies";
import {
  exportStatisticsReport,
  exportWorkStationReport,
} from "@/api/api";
import { WorkStationGroupServiceProxy } from "@/service-proxies/app-v2/workStation.service-proxies";
import { FieldSettingServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'

const pssp = new ProductionStatisticsServiceProxy();
const ssp = new ShiftServiceProxy();
const pptpsp = new ProductionPlanTypeProductTypeServiceProxy();
const wsgsp = new WorkStationGroupServiceProxy();
const fssp = new FieldSettingServiceProxy()

export default Vue.extend({
  data() {
    return {
      selectArr: [],
      defaultSelect: {},
      typeSearch: "产品查询",
      tabArr: [],
      chooseTab: 0,
      mode: ["month", "month"],
      productArr: [],
      statisticsArr: [
        {
          name: "按班次",
          id: "SHIFT",
        },
        {
          name: "按月",
          id: "MONTH",
        },
        {
          name: "按周",
          id: "WEEK",
        },
        {
          name: "按日",
          id: "DAY",
        },
      ],
      form: {
        type: "",
        name: "",
        statistics: "DAY",
        shift: [],
        timeRound: [null, null],
        planCode: "",
      },
      shiftDate: "",
      monthDate: [],
      weekDate1: "",
      weekDate2: "",
      dayDate: [],
      pagination: {
        total: 0,
        pageSize: 10,
        current: 1,
      },
      selectedIds: [],
      selectedRowKeys: [], // 复选框勾选，多选
      selectedRows: [], // 复选框勾选的数据项(所有字段的集合)
      selectedIds2: [],
      selectedRowKeys2: [],
      selectedRows2: [],
      palnCol: [
        {
          title: "日期",
          key: "date",
          dataIndex: "date",
          align: "center",
          width: 110,
          scopedSlots: { customRender: "date" },
        },
        {
          title: "产品编码",
          key: "productCode",
          dataIndex: "productCode",
          align: "center",
          width: 75,
        },
        {
          title: "产品名称",
          key: "productName",
          dataIndex: "productName",
          align: "center",
          width: 75,
        },
        {
          title: "规格型号",
          key: "standardModel",
          dataIndex: "standardModel",
          align: "center",
          width: 75,
        },
        {
          title: "工位名称",
          key: "workStationName",
          dataIndex: "workStationName",
          align: "center",
          width: 75,
        },
        {
          title: "工序编码",
          key: "processCode",
          dataIndex: "processCode",
          align: "center",
          width: 75,
        },
        {
          title: "工序名称",
          key: "processName",
          dataIndex: "processName",
          align: "center",
          width: 75,
        },
        {
          title: "工序顺序",
          key: "processSort",
          dataIndex: "processSort",
          align: "center",
          width: 75,
        },
        {
          title: "指派数量",
          key: "assignNum",
          dataIndex: "assignNum",
          align: "center",
          width: 75,
        },
        {
          title: "报工数量",
          key: "reportNum",
          dataIndex: "reportNum",
          align: "center",
          width: 75,
        },
        {
          title: "采集数量",
          key: "collectionNum",
          dataIndex: "collectionNum",
          align: "center",
          width: 75,
        },
        {
          title: "完工差异",
          key: "completeDifference",
          dataIndex: "completeDifference",
          align: "center",
          width: 75,
        },
        {
          title: "完工比",
          key: "completeCompare",
          dataIndex: "completeCompare",
          align: "center",
          width: 65,
        },
        {
          title: "加工时间",
          key: "workTime",
          dataIndex: "workTime",
          align: "center",
          width: 75,
        },
        {
          title: "标准工时",
          key: "standardTime",
          dataIndex: "standardTime",
          align: "center",
          width: 75,
        },
        {
          title: "加工工时",
          key: "processTime",
          dataIndex: "processTime",
          align: "center",
          width: 75,
        },
      ],
      planData: [],
      workStationData: [],
      shiftArr: [],
      checkedKeys: [],
      expendKeys: [],
      treeData: [],
      workStatoinItems: [],
      defaultNumberChecked: 0,
      extraCols: [],
      planId: ''
    };
  },
  watch: {
    pagination: {
      handler(val) {
        this.pagination.showTotal = (total) => {
          return this.$t("Total…items").replace("{0}", ` ${val.total} `);
        };
      },
      immediate: true,
    },
  },
  computed: {
    // 导出
    exportFn() {
      // if(this.planData <= 0) {
      //   this.$message.error('请先查询');
      // }
      // else {
      let filterObj = this.excelSearch();
      let arr = this.$route.fullPath.split("/");
      return exportStatisticsReport.bind(this, filterObj, {
        bizCode: "page_plan_report_work_order",
        bizDataId: this.form.type,
        tenantId: "",
      });
      // }
    },
        // 导出
    exportWork() {
      // if(this.planData <= 0) {
      //   this.$message.error('请先查询');
      // }
      // else {
      let filterObj = this.excelSearch();
      return exportWorkStationReport.bind(this, filterObj);
      // }
    },
    workStationIdCol() {
      return [
        {
          title: "计划编号",
          key: "planCode",
          dataIndex: "planCode",
          align: "center",
          width: 160,
        },
        {
          title: "产品编码",
          key: "productCode",
          dataIndex: "productCode",
          align: "center",
          width: 75,
        },
        {
          title: "产品名称",
          key: "productName",
          dataIndex: "productName",
          align: "center",
          width: 75,
        },
        {
          title: "规格型号",
          key: "standardModel",
          dataIndex: "standardModel",
          align: "center",
          width: 75,
        },
        {
          title: "工位名称",
          key: "workStationName",
          dataIndex: "workStationName",
          align: "center",
          width: 120,
        },
        {
          title: "加工人员",
          key: "startPerson",
          dataIndex: "startPerson",
          align: "center",
          width: 75,
        },
        {
          title: "工序编码",
          key: "processCode",
          dataIndex: "processCode",
          align: "center",
          width: 100,
        },
        {
          title: "工序名称",
          key: "processName",
          dataIndex: "processName",
          align: "center",
          width: 100,
        },
        {
          title: "工序顺序",
          key: "processSort",
          dataIndex: "processSort",
          align: "center",
          width: 75,
        },
        {
          title: "工位产能",
          key: "stationProductionCapacity",
          dataIndex: "stationProductionCapacity",
          align: "center",
          width: 75,
        },
        {
          title: "报工数量",
          key: "reportNum",
          dataIndex: "reportNum",
          align: "center",
          width: 75,
        },
        {
          title: "采集数量",
          key: "collectionNum",
          dataIndex: "collectionNum",
          align: "center",
          width: 75,
        },
        {
          title: "合格数量",
          key: "qualifyNum",
          dataIndex: "qualifyNum",
          align: "center",
          width: 75,
        },
        {
          title: "报废数量",
          key: "scrappedNum",
          dataIndex: "scrappedNum",
          align: "center",
          width: 75,
        },
        {
          title: "完工差异",
          key: "finishedDifference",
          dataIndex: "finishedDifference",
          align: "center",
          width: 75,
        },
        {
          title: "报工工时（天/时/分/秒）",
          key: "workTime",
          dataIndex: "workTime",
          align: "center",
          width: 180,
          customRender: (time) => {
            return this.getTime(time)
          },
        },
        {
          title: "开工时间",
          key: "startTime",
          dataIndex: "startTime",
          align: "center",
          width: 180,
          customRender: (time) => dayjs(time).format("YYYY-MM-DD HH:mm:ss"),
        },
        {
          title: "报工时间",
          key: "endTime",
          dataIndex: "endTime",
          align: "center",
          width: 180,
          customRender: (time) => dayjs(time).format("YYYY-MM-DD HH:mm:ss"),
        },
        ...this.extraCols,
        {
          title: "备注",
          key: "remark",
          dataIndex: "remark",
          align: "center",
          width: 180,
        },
      ]
    }
  },
  methods: {
    // 获取用户自定义字段
    async getExtraFields () {
      let extraCols = []
      let res = await fssp.listFieldSettings('page_plan_report_work_order')
      res.map(item => {
        if (item.isDisplay) {
          extraCols.push({
            title: item.name,
            key: item.code,
            dataIndex: item.code,
            align: 'center',
            width: 120
          })
        }
      })
      this.extraCols = extraCols
    },
    getSelectArr() {
      let arr = JSON.parse(localStorage.getItem('coproduction'));
      let  arrX = [];

      for(var i=0; i<arr.length; i++) {
        let obj = {
          label: arr[i].name,
          value: arr[i].id
        }
        arrX.push(obj)
      }
      this.selectArr = arrX;

      this.defaultSelect = {
        key: arr[0].id,
        label: arr[0].name
      }

      this.planId = arr[0].id

    },
    changeProduction(e) {
      console.log(e);
      this.planId = e.key
      this.getTypeList();
      this.form.type = ''
      this.searchFn()

    },
      getTime(val) {
      var days = val / 60 / 60 / 24;
      var daysRound = Math.floor(days);
      var hours = val / 60 / 60 - (24 * daysRound);
      var hoursRound = Math.floor(hours);
      var minutes = val / 60 - (24 * 60 * daysRound) - (60 * hoursRound);
      var minutesRound = Math.floor(minutes);
      var seconds = val - (24 * 60 * 60 * daysRound) - (60 * 60 * hoursRound) - (60 * minutesRound);
      var time = daysRound + '/' + hoursRound + '/' + minutesRound + '/' + seconds
      // var time = daysRound + '天'+ hoursRound + '时'+ minutesRound + '分'+ seconds + '秒'
      return time;
      },
    callback(e) {
     console.log(1111,e)
    },
    onChange() {
     this.search()
    },
    setWorkStationList() {
      const List = [];
      const recheckKeys = [];
      console.log("workStatoinItems:", this.workStatoinItems);
      console.log(this.checkedKeys);
      this.workStatoinItems.map((res) => {
        if (
          this.checkedKeys.includes(this.addKeyId(res)) &&
          !recheckKeys.includes(res.id) &&
          !res.isGroup
        ) {
          recheckKeys.push(res.id);
          const data = {
            id: res.id,
            name: res.title,
            code: res.code,
            standardEfficiency: res.standardEfficiency,
          };
          List.push(data);
        }
      });
      return List;
    },
    expandKey(value) {
      this.expendKeys = value;
    },
    addKeyId(item) {
      const key = item.id + "-" + item.parentId;
      return key;
    },
    async getTreeList() {
      this.workStatoinItems = [];
      this.expendKeys = [];
      this.checkedKeys = [];

      wsgsp.workStationGroupList().then((res) => {
        if (res) {
          const keys = [];
          // let i = 0
          const data = res.reduce((total, value) => {
            const key = value.id + "-" + value.parentId;
            total.push({
              ...value,
              key: key,
            });
            // if(value.isWorkStation){
            //   if(i < 5){
            //     keys.push(key)
            //     i = 1 + i
            //     console.log(keys);

            //   }
            // } else {
            //   this.expendKeys.push(key)
            // }
            return total;
          }, []);
          this.treeData = DataTreeNode.arrayToTree(data);
          this.treeData.map((item) => {
            if (item.children && item.children.length) {
              item.children.map((t) => {
                this.getTreeSelect(t, keys);
              });
            } else {
              keys.push(item.key);
            }
          });

          this.workStatoinItems = data;
          this.checkedKeys = keys;
          console.log(8888, this.checkedKeys);
          this.searchFn();
        }
      });
    },
    getTreeSelect(data, arr) {
      if (data.children && data.children.length) {
        data.children.map((m) => {
          this.getTreeSelect(m, arr);
        });
      } else {
        arr.push(data.key);
      }
      return arr;
    },
    onSelect(value) {
      console.log(value);
      this.checkedKeys = value;
    },
    changeStat() {
      this.tabArr = [];
      this.chooseTab = 0;
    },
    changeTab(e) {
      console.log(e,77777);
      this.selectedIds = [];
      this.selectedRowKeys = [];
      this.selectedRows = [];
      this.selectedIds2 = [];
      this.selectedRowKeys2 = [];
      this.selectedRows2 = [];
      this.search();
    },
    getToday() {
      this.form.timeRound[1] = moment(new Date()).format("YYYY-MM-DD");
      this.form.timeRound[0] = moment(new Date())
        .subtract(7, "days")
        .format("YYYY-MM-DD");
      console.log(this.form.timeRound);
    },
    getTypeList() {
      let arr = this.$route.fullPath.split("/");
      pptpsp.getProductTypeList(this.planId).then((res) => {
        console.log(res);
        this.productArr = res;
        // if (res.length > 0) {
        //   this.form.type = res[0].id;
        // }
      });
    },
    getShift() {
      ssp.getShiftIndexName().then((res) => {
        console.log(res,"p");
        this.shiftArr = res.keyNameDTOList;

        if (this.shiftArr.length > 0) {
          this.form.shift = [this.shiftArr[0].key];
          console.log(5555,this.form.shift)
        }
      });
    },
    monthChangeA(value, mode) {
      this.form.timeRound = value;
      this.mode2 = [
        mode[0] === "date" ? "month" : mode[0],
        mode[1] === "date" ? "month" : mode[1],
      ];
    },
    monthChangeB(value) {
      this.form.timeRound = value;
    },
    customRow(record, index) {
      return {
        on: {
          click: () => {
            console.log(record, this.selectedRows);
            let id = null;
            let index = null;
            let bol = false;
            let copy = JSON.parse(JSON.stringify(this.selectedRows));
            for (var i = 0; i < copy.length; i++) {
              if (copy[i].id == record.id) {
                id = record.id;
                index = i;
                bol = true;
              }
            }

            console.log(id, index, bol);

            if (bol == true) {
              copy.splice(index, 1);
            } else if (bol == false) {
              copy.push(record);
            }

            this.selectedRows = JSON.parse(JSON.stringify(copy));
            let idsArr = [];
            let keysArr = [];
            for (var j = 0; j < copy.length; j++) {
              idsArr.push(copy[j].id);

              for (var v = 0; v < this.planData.length; v++) {
                if (this.planData[v].id == copy[j].id) {
                  keysArr.push(v);
                }
              }
            }

            this.selectedIds = idsArr;
            this.selectedRowKeys = keysArr;
            console.log(this.selectedRows, idsArr, keysArr);
          },
        },
      };
    },
    customRow2(record, index) {
      return {
        on: {
          click: () => {
            console.log(record, this.selectedRows2);
            let id = null;
            let index = null;
            let bol = false;
            let copy = JSON.parse(JSON.stringify(this.selectedRows2));
            for (var i = 0; i < copy.length; i++) {
              if (copy[i].id == record.id) {
                id = record.id;
                index = i;
                bol = true;
              }
            }

            console.log(id, index, bol);

            if (bol == true) {
              copy.splice(index, 1);
            } else if (bol == false) {
              copy.push(record);
            }

            this.selectedRows2 = JSON.parse(JSON.stringify(copy));
            let idsArr = [];
            let keysArr = [];
            for (var j = 0; j < copy.length; j++) {
              idsArr.push(copy[j].id);

              for (var v = 0; v < this.workStationData.length; v++) {
                if (this.workStationData[v].id == copy[j].id) {
                  keysArr.push(v);
                }
              }
            }

            this.selectedIds2 = idsArr;
            this.selectedRowKeys2 = keysArr;
            console.log(this.selectedRows2, idsArr, keysArr);
          },
        },
      };
    },
    onSelectChange2(selectedRowKeys, selectedRows) {
      this.selectedRowKeys2 = selectedRowKeys;
      this.selectedRows2 = selectedRows;
      let arr = [];
      this.selectedRows2.forEach((a) => {
        arr.push(a.id);
      });
      this.selectedIds2 = arr;
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      console.log(selectedRowKeys, selectedRows);
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
      let arr = [];
      this.selectedRows.forEach((a) => {
        arr.push(a.id);
      });
      this.selectedIds = arr;
    },
    // 日期查询
    dateChange(e) {
      console.log(e, "aaaaaaaaaaaaaaaaaaa");
    },
    getYearAndMonth(start, end) {
      console.log(start, end);
      var result = [];
      var starts = start.split("-");
      var ends = end.split("-");
      var staYear = parseInt(starts[0]);
      var staMon = parseInt(starts[1]);
      var endYear = parseInt(ends[0]);
      var endMon = parseInt(ends[1]);
      while (staYear <= endYear) {
        if (staYear === endYear) {
          while (staMon < endMon) {
            staMon++;
            var str = staYear + "-" + (staMon >= 10 ? staMon : "0" + staMon);
            result.push(str);
          }
          staYear++;
        } else {
          staMon++;
          if (staMon > 12) {
            staMon = 1;
            staYear++;
          }
          var str = staYear + "-" + (staMon >= 10 ? staMon : "0" + staMon);
          result.push(str);
        }
      }
      console.log(result);
      result.unshift(start);
      return result;
    },
    getDiffDate(start, end) {
      var startTime = this.getDate(start);
      var endTime = this.getDate(end);
      var dateArr = [];
      while (endTime.getTime() - startTime.getTime() > 0) {
        var year = startTime.getFullYear();

        var month =
          startTime.getMonth().toString().length === 1
            ? "0" + (parseInt(startTime.getMonth().toString(), 10) + 1)
            : startTime.getMonth() + 1;

        var day =
          startTime.getDate().toString().length === 1
            ? "0" + startTime.getDate()
            : startTime.getDate();

        dateArr.push(year + "-" + month + "-" + day);

        startTime.setDate(startTime.getDate() + 1);
      }

      return dateArr;
    },

    getDate(datestr) {
      var temp = datestr.split("-");

      if (temp[1] === "01") {
        temp[0] = parseInt(temp[0], 10) - 1;

        temp[1] = "12";
      } else {
        temp[1] = parseInt(temp[1], 10) - 1;
      }

      //new Date()的月份入参实际都是当前值-1

      var date = new Date(temp[0], temp[1], temp[2]);

      return date;
    },

    getYearWeek(date) {
      var date2 = new Date(date.getFullYear(), 0, 1);
      var day1 = date.getDay();
      if (day1 == 0) day1 = 7;
      var day2 = date2.getDay();
      if (day2 == 0) day2 = 7;
      let d = Math.round(
        (date.getTime() -
          date2.getTime() +
          (day2 - day1) * (24 * 60 * 60 * 1000)) /
          86400000
      );
      return dayjs(date).format("YYYY") + "-" + Math.ceil(d / 7);
    },
    unique(arr) {
      if (!Array.isArray(arr)) {
        console.log("type error!");
        return;
      }
      var array = [];
      for (var i = 0; i < arr.length; i++) {
        if (array.indexOf(arr[i]) === -1) {
          array.push(arr[i]);
        }
      }
      return array;
    },

    // 第n年的第n周，获取开始和结束时间 （星期一为一周的开始）
    week_date(weekstr) {
      let year = weekstr.split("-")[0];
      let weekNo = weekstr.split("-")[1];
      // 此年1号是星期几
      let oneday = new Date(year + "-01-01").getDay(); //0-6
      // 方便计算，当为星期天时为7
      if (oneday == 0) {
        oneday = 7;
      }

      let one_fistday;
      let one_lastday;
      // 如果1号刚好是星期一
      if (oneday == 1) {
        one_fistday = year + "-01-01";
        one_lastday = year + "-01-07";
      } else {
        let jj = 8 - oneday;
        one_fistday =
          year -
          1 +
          "-12-" +
          (31 - oneday + 2 > 9 ? 31 - oneday + 2 : "0" + (31 - oneday + 2));
        one_lastday = year + "-01-" + (jj > 9 ? jj : "0" + jj);
      }

      let fistday;
      let lastday;
      // 如果刚好是第一周
      if (weekNo == 1) {
        fistday = one_fistday;
        lastday = one_lastday;
      } else {
        fistday = this.addDate(one_lastday, (weekNo - 2) * 7 + 1);
        lastday = this.addDate(one_lastday, (weekNo - 1) * 7);
      }
      return [fistday, lastday];
    },

    //日期加减法  date参数为计算开始的日期，days为需要加的天数
    //格式:addDate('2017-1-11',20)
    addDate(date, days) {
      var d = new Date(date);
      d.setDate(d.getDate() + days);
      var m = d.getMonth() + 1;
      return (
        d.getFullYear() +
        "-" +
        (m > 9 ? m : "0" + m) +
        "-" +
        (d.getDate() > 9 ? d.getDate() : "0" + d.getDate())
      );
    },

    searchFn() {
      this.chooseTab = 0;
      this.selectedIds = [];
      this.selectedRowKeys = [];
      this.selectedRows = [];
      this.search();
    },
    search() {
      console.log(this.form);
      // {
      //   "date": "",
      //   "endDate": "",
      //   "month": 0,
      //   "productName": "",
      //   "productTypeId": "",
      //   "shiftIndex": 0,
      //   "startDate": "",
      //   "statisticalMethod": "",
      //   "week": 0,
      //   "year": 0
      // }

      let obj = {};
      console.log(this.form.timeRound);
      if (this.form.statistics == "SHIFT") {
        this.tabArr = [];
        let arr = this.getDiffDate(
          moment(this.form.timeRound[0]).format("YYYY-MM-DD"),
          moment(this.form.timeRound[1]).format("YYYY-MM-DD")
        );

        arr.push(moment(this.form.timeRound[1]).format("YYYY-MM-DD"));
        console.log(8888,arr)
        arr.forEach((z) => {
        this.form.shift.forEach((x) => {
          this.shiftArr.forEach((y) => {
            if (y.key == x) {
              this.tabArr.push(
                moment(z).format("YYYY-MM-DD") +
                  " " +
                  y.name
              );
            }
          });
        });
        })
        this.tabArr.reverse();
        let arrTab =  this.tabArr[this.chooseTab].split(" ")
        let shiftIndex = ""
        this.shiftArr.forEach(res =>{
          if(res.name === arrTab[1]) {
           shiftIndex = res.key
          }
        })
        obj = {
          date: moment(arrTab[0]).format("YYYY-MM-DD"),
          productName: this.form.name,
          productTypeId: this.form.type == undefined ? "" : this.form.type,
          shiftIndex: shiftIndex,
          statisticalMethod: this.form.statistics,
          planCode: this.form.planCode,
          workStationBOList: this.setWorkStationList(),
        };
      } else if (this.form.statistics == "MONTH") {
        let time1 = moment(this.form.timeRound[0]).format(
          "YYYY-MM-01 00:00:00"
        );
        let time2 = moment(this.form.timeRound[1]).format(
          "YYYY-MM-28 23:59:59"
        );
        console.log(time1, time2,"tttt");
        console.log(moment(time2).format("YYYY-MM"),"ppp")
        this.tabArr = this.getYearAndMonth(
          moment(time1).format("YYYY-MM"),
          moment(time2).format("YYYY-MM")
        );
        this.tabArr.reverse();
        console.log(
          this.tabArr[this.chooseTab],
          "sssssssssssssssssssssssssssssssssssssssssss"
        );
        obj = {
          startDate: moment(this.tabArr[this.chooseTab]).format(
            "YYYY-MM-01 00:00:00"
          ),
          endDate: moment(this.tabArr[this.chooseTab])
            .endOf("month")
            .format("YYYY-MM-DD 23:59:59"),
          productName: this.form.name,
          productTypeId: this.form.type == undefined ? "" : this.form.type,
          statisticalMethod: this.form.statistics,
          year: this.tabArr[this.chooseTab].split("-")[0] - 0,
          month: this.tabArr[this.chooseTab].split("-")[1] - 0,
          planCode: this.form.planCode,
          workStationBOList: this.setWorkStationList(),
        };
      } else if (this.form.statistics == "WEEK") {
        console.log(this.weekDate1, this.weekDate2);
        let tabArr = this.getDiffDate(
          moment(this.form.timeRound[0]).format("YYYY-MM-DD"),
          moment(this.form.timeRound[1]).format("YYYY-MM-DD")
        );
        let arr = [];
        tabArr.forEach((x) => {
          arr.push(this.getYearWeek(new Date(x)));
        });
        arr.reverse();
        this.tabArr = this.unique(arr);
        console.log(this.tabArr);

        let thisDate = this.week_date(this.tabArr[this.chooseTab]);
        console.log(thisDate);

        obj = {
          startDate: moment(thisDate[0]).format("YYYY-MM-DD 00:00:00"),
          endDate: moment(thisDate[1]).format("YYYY-MM-DD 23:59:59"),
          productName: this.form.name,
          productTypeId: this.form.type == undefined ? "" : this.form.type,
          statisticalMethod: this.form.statistics,
          year: this.tabArr[this.chooseTab].split("-")[0] - 0,
          week: this.tabArr[this.chooseTab].split("-")[1] - 0,
          planCode: this.form.planCode,
          workStationBOList: this.setWorkStationList(),
        };
      } else if (this.form.statistics == "DAY") {
        let time1 = moment(this.form.timeRound[0]).format(
          "YYYY-MM-DD 00:00:00"
        );
        let time2 = moment(this.form.timeRound[1]).format(
          "YYYY-MM-DD 23:59:59"
        );
        console.log(time1, time2);
        this.tabArr = this.getDiffDate(
          moment(time1).format("YYYY-MM-DD"),
          moment(time2).format("YYYY-MM-DD")
        );
        this.tabArr.push(moment(time2).format("YYYY-MM-DD"));
        this.tabArr.reverse();
        obj = {
          startDate: moment(this.tabArr[this.chooseTab]).format(
            "YYYY-MM-DD 00:00:00"
          ),
          endDate: moment(this.tabArr[this.chooseTab]).format(
            "YYYY-MM-DD 23:59:59"
          ),
          date: this.tabArr[this.chooseTab],
          productName: this.form.name,
          productTypeId: this.form.type == undefined ? "" : this.form.type,
          statisticalMethod: this.form.statistics,
          planCode: this.form.planCode,
          workStationBOList: this.setWorkStationList(),
        };
      }
      if(this.typeSearch === "产品查询") {
      pssp
        .getProductionStatisticReport(obj)
        .then((res) => {
          console.log(res);
          // this.planData = res;
          let copy = JSON.parse(JSON.stringify(res));

          for (var i = 0; i < copy.length; i++) {
            copy[i].id = (i + 1).toString();
            copy[i].index = i;
          }
          this.planData = copy;

          console.log(this.planData);
          // this.planData.forEach((x) => {
          //   x.date = dayjs(x.date).format('YYYY-MM-DD HH:mm:ss')
          // })
        })
        .catch((err) => {
          console.log(err);
        });
      }else {
      pssp
        .getProductionStatisticWorkStationReport(obj)
        .then((res) => {
          console.log(res, 5555);
          let copy = JSON.parse(JSON.stringify(res));
          for (var i = 0; i < copy.length; i++) {
            copy[i].id = (i + 1).toString();
            copy[i].index = i;
          }
          this.workStationData = copy;
        })
        .catch((err) => {
          console.log(err);
        });
      }
    },
    excelSearch() {
      let selectedRows = [];
      if (this.selectedRows.length <= 0) {
        selectedRows = [];
      } else {
        this.selectedRows.forEach((z) => {
          let obj = {
            poProcessId: z.poProcessId,
            workStationId: z.workStationId,
          };
          selectedRows.push(obj);
        });
      }

      let obj = {};
      let param = {}
      if (this.form.statistics == "SHIFT") {
        this.tabArr = [];
        let arrX = [];
        let shiftArr = [];
        let arr = this.getDiffDate(
          moment(this.form.timeRound[0]).format("YYYY-MM-DD"),
          moment(this.form.timeRound[1]).format("YYYY-MM-DD")
        );

        arr.push(moment(this.form.timeRound[1]).format("YYYY-MM-DD"));
        arr.forEach((z) => {
          shiftArr = []
        this.form.shift.forEach((x) => {
          this.shiftArr.forEach((y) => {
            if (y.key == x) {
              this.tabArr.push(
                moment(z).format("YYYY-MM-DD") +
                  " " +
                  y.name
              );
              shiftArr.push(y);
            }
            })
          });
        });
        this.shiftArr.forEach((c) => {
          arrX.push(moment(this.form.timeRound[1]).format("YYYY-MM-DD"));
        });
        let dateArr = arr.reverse()
        this.tabArr.reverse();
        let arrTab =  this.tabArr[this.chooseTab].split(" ")
        let shiftIndex = ""
        this.shiftArr.forEach(res =>{
          if(res.name === arrTab[1]) {
           shiftIndex = res.key
          }
        })
        console.log(88888,this.shiftArr)
        obj = {
          date: [arrTab[0]],
          productName: this.form.name,
          productTypeId: this.form.type == undefined ? "" : this.form.type,
          shiftList: shiftArr,
          statisticalMethod: this.form.statistics,
          workStationAndPoProcessList: selectedRows,
        };
        param = {
          date: [arrTab[0]],
          productName: this.form.name,
          productTypeId: this.form.type == undefined ? "" : this.form.type,
          shiftList: shiftArr,
          statisticalMethod: this.form.statistics,
          workStationBOList: this.setWorkStationList(),
          planCode: this.form.planCode,
        };
      } else if (this.form.statistics == "MONTH") {
        let time1 = moment(this.form.timeRound[0]).format(
          "YYYY-MM-01 00:00:00"
        );
        let time2 = moment(this.form.timeRound[1]).format(
          "YYYY-MM-28 23:59:59"
        );
        console.log(time1, time2);
        this.tabArr = this.getYearAndMonth(
          moment(time1).format("YYYY-MM"),
          moment(time2).format("YYYY-MM")
        );
        this.tabArr.reverse();

        let monthArr = [];
        this.tabArr.forEach((x) => {
          monthArr.push(x.split("-")[1] - 0);
        });

        monthArr = this.unique(monthArr);

        let dateArr = [];
        if (this.selectedRows.length == 0) {
          this.tabArr.forEach((a) => {
            dateArr.push(moment(a).format("YYYY-MM-01"));
          });
        } else {
          dateArr.push(
            moment(this.tabArr[this.chooseTab]).format("YYYY-MM-01")
          );
        }

        console.log(
          this.tabArr[this.chooseTab],
          "sssssssssssssssssssssssssssssssssssssssssss"
        );

        obj = {
          date: dateArr,
          startDate: moment(this.tabArr[this.chooseTab]).format(
            "YYYY-MM-01 00:00:00"
          ),
          endDate: moment(this.tabArr[this.chooseTab])
            .endOf("month")
            .format("YYYY-MM-DD 23:59:59"),
          productName: this.form.name,
          productTypeId: this.form.type == undefined ? "" : this.form.type,
          statisticalMethod: this.form.statistics,
          year: this.tabArr[this.chooseTab].split("-")[0] - 0,
          month: monthArr,
          workStationAndPoProcessList: selectedRows,
        };
        param = {
          date: dateArr,
          startTime: moment(this.tabArr[this.chooseTab]).format(
            "YYYY-MM-01 00:00:00"
          ),
          endTime: moment(this.tabArr[this.chooseTab])
            .endOf("month")
            .format("YYYY-MM-DD 23:59:59"),
          productName: this.form.name,
          productTypeId: this.form.type == undefined ? "" : this.form.type,
          statisticalMethod: this.form.statistics,
          year: this.tabArr[this.chooseTab].split("-")[0] - 0,
          month: monthArr,
          workStationBOList: this.setWorkStationList(),
          planCode: this.form.planCode,
        };
      } else if (this.form.statistics == "WEEK") {
        console.log(this.weekDate1, this.weekDate2);
        let tabArr = this.getDiffDate(
          moment(this.form.timeRound[0]).format("YYYY-MM-DD"),
          moment(this.form.timeRound[1]).format("YYYY-MM-DD")
        );
        let arr = [];
        tabArr.forEach((x) => {
          arr.push(this.getYearWeek(new Date(x)));
        });
        arr.reverse();
        this.tabArr = this.unique(arr);
        console.log(this.tabArr);

        let weekArr = [];
        this.tabArr.forEach((x) => {
          weekArr.push(x.split("-")[1] - 0);
        });

        let thisDate = this.week_date(this.tabArr[this.chooseTab]);
        let dateArr = [];
        // if(this.selectedRows.length != 0) {
        //   dateArr.push(moment(thisDate[0]).format('YYYY-MM-DD'))
        // }
        // else {
        this.tabArr.forEach((x) => {
          let res = this.week_date(x);
          dateArr.push(moment(res[0]).format("YYYY-MM-DD"));
        });
        // }

        obj = {
          date: dateArr,
          startDate: moment(thisDate[0]).format("YYYY-MM-DD 00:00:00"),
          endDate: moment(thisDate[1]).format("YYYY-MM-DD 23:59:59"),
          productName: this.form.name,
          productTypeId: this.form.type == undefined ? "" : this.form.type,
          statisticalMethod: this.form.statistics,
          year: this.tabArr[this.chooseTab].split("-")[0] - 0,
          week: weekArr,
          workStationAndPoProcessList: selectedRows,
        };
        param = {
          date: dateArr,
          startTime: moment(thisDate[0]).format("YYYY-MM-DD 00:00:00"),
          endTime: moment(thisDate[1]).format("YYYY-MM-DD 23:59:59"),
          productName: this.form.name,
          productTypeId: this.form.type == undefined ? "" : this.form.type,
          statisticalMethod: this.form.statistics,
          year: this.tabArr[this.chooseTab].split("-")[0] - 0,
          week: weekArr,
          planCode: this.form.planCode,
          workStationBOList: this.setWorkStationList(),
        };
      } else if (this.form.statistics == "DAY") {
        let time1 = moment(this.form.timeRound[0]).format(
          "YYYY-MM-DD 00:00:00"
        );
        let time2 = moment(this.form.timeRound[1]).format(
          "YYYY-MM-DD 23:59:59"
        );
        console.log(time1, time2);
        this.tabArr = this.getDiffDate(
          moment(time1).format("YYYY-MM-DD"),
          moment(time2).format("YYYY-MM-DD")
        );
        this.tabArr.push(moment(time2).format("YYYY-MM-DD"));
        this.tabArr.reverse();

        let dayArr = [];
        this.tabArr.forEach((x) => {
          dayArr.push(x);
        });

        let dateArr = [];
        this.tabArr.forEach((x) => {
          console.log(8888,x)
          // let res = this.week_date(x);
          // dateArr.push(moment(res[0]).format("YYYY-MM-DD"));
          dateArr.push(x)
        });

        obj = {
          date: dateArr,
          startDate: moment(this.tabArr[this.chooseTab]).format(
            "YYYY-MM-DD 00:00:00"
          ),
          endDate: moment(this.tabArr[this.chooseTab]).format(
            "YYYY-MM-DD 23:59:59"
          ),
          productName: this.form.name,
          productTypeId: this.form.type == undefined ? "" : this.form.type,
          statisticalMethod: this.form.statistics,
          workStationAndPoProcessList: selectedRows,
        };
        param = {
          date: dateArr,
          startTime: moment(this.tabArr[this.chooseTab]).format(
            "YYYY-MM-DD 00:00:00"
          ),
          endTime: moment(this.tabArr[this.chooseTab]).format(
            "YYYY-MM-DD 23:59:59"
          ),
          productName: this.form.name,
          productTypeId: this.form.type == undefined ? "" : this.form.type,
          statisticalMethod: this.form.statistics,
          workStationBOList: this.setWorkStationList(),
          planCode: this.form.planCode,
        };
      }

      return this.typeSearch === "产品查询" ? obj : param;
    },
  },
  created() {
    this.getSelectArr();
    this.getToday();
    this.getTypeList();
    this.getShift();
    this.getTreeList();
    this.getExtraFields();
  },
});
</script>

<style scoped lang="less">
.comp_wrap {
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: row nowrap;
  position: relative;

  .comp_left {
    width: 310px;
    height: 100%;
    background-color: white;
    border: 1px solid #e9e9e9;
    margin-right: 8px;

    .comp_input {
      height: 50px;
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      width: 100%;
      box-sizing: border-box;
      padding-left: 10px;
      .comp_span {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
        font-weight: bold;
      }
    }
  }

  .comp_right {
    width: auto;
    height: 100%;
    background-color: white;
    border: 1px solid #e9e9e9;
    position: absolute;
    left: 318px;
    right: 0;
    top: 0;
    bottom: 0;

    .comp_right_excl {
      width: 100%;
      height: 50px;
      display: flex;
      align-items: center;
    }

    .comp_right_header {
      width: 100%;
      height: 40px;
    }

    .comp_right_time {
      width: 100%;
      height: 40px;
      margin-bottom: 10px;
    }
  }

  /deep/ .ant-checkbox-wrapper + .ant-checkbox-wrapper {
    margin-left: 0;
  }

  /deep/ .ant-checkbox-wrapper {
    margin-right: 5px;
  }
  .mdc-left-tree {
    border: 1px solid #e9e9e9;
    margin-bottom: 16px;
    overflow: auto;
  }
}
</style>
